var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-container',{attrs:{"tag":"section"}},[_c('h3',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('nav.contact.contact-with-us')))]),_c('contact-list',{attrs:{"entries":_vm.entries}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }